import { useState } from 'react';
import Modal, { ModalBody, ModalFooter } from './ui/Modal';
import Button from './ui/Button';
import TextInput from './ui/TextInput';

export default function DeleteAccountModal({ onClose, onConfirm }) {
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');

  const handleFirstConfirm = () => {
    setStep(2);
  };

  const handleFinalConfirm = () => {
    if (confirmText === 'DELETE') {
      onConfirm();
    }
  };

  const modalTitle = step === 1 ? 'Delete Account?' : 'Final Confirmation';

  return (
    <Modal isOpen onClose={onClose} title={modalTitle} size="md">
      <ModalBody>
        {step === 1 ? (
          <p className="text-gray-600 dark:text-dark-muted">
            Are you sure you want to delete your account? This cannot be undone. All your data will
            be permanently deleted.
          </p>
        ) : (
          <>
            <p className="text-gray-600 dark:text-dark-muted mb-4">
              This is permanent. Type <strong className="text-danger">DELETE</strong> to confirm.
            </p>
            <TextInput
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
              placeholder="Type DELETE"
              autoFocus
            />
          </>
        )}
      </ModalBody>
      <ModalFooter align="split">
        {step === 1 ? (
          <>
            <Button
              variant="secondary"
              fullWidth
              onClick={onClose}
              className="border-2 border-gray-300 dark:border-dark-border text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-border"
            >
              Cancel
            </Button>
            <Button variant="destructive" fullWidth onClick={handleFirstConfirm}>
              Yes, Delete
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="secondary"
              fullWidth
              onClick={onClose}
              className="border-2 border-gray-300 dark:border-dark-border text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-border"
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              fullWidth
              onClick={handleFinalConfirm}
              disabled={confirmText !== 'DELETE'}
            >
              Delete Account
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}
